export { Avatar } from './Avatar';
export { renderAvatar } from './renderAvatar';
export { useAvatar } from './useAvatar';
export type { AvatarSlots, AvatarProps, AvatarState } from './Avatar.types';
